import { fetcher } from '@commenda/utils';
import { UpdateTransferPricingPolicyParams } from './types';

const updatePolicy = async (
  id: string,
  body: UpdateTransferPricingPolicyParams
) => {
  const res = await fetcher(`transfer-pricing/policy/${id}`, {
    method: 'POST',
    body,
  });
  return res;
};

export default updatePolicy;
